import React, { useEffect, useRef } from 'react';
import './options-menu.css';

export default function OptionsMenu({ options, onClose }) {
  const menuRef = useRef();

  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onClose();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  return (
    <div ref={menuRef} className="options-menu">
      {options.map((opt, index) => (
        <div
          key={index}
          className="option-item"
          onClick={() => {
            opt.onClick();
            onClose();
          }}
        >
          {opt.img && <img src={opt.img} className='option-icon' />}
          {opt.label}
        </div>
      ))}
    </div>
  );
}
